"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompetitionEntryUpdateCommand = instanceOfCompetitionEntryUpdateCommand;
exports.CompetitionEntryUpdateCommandFromJSON = CompetitionEntryUpdateCommandFromJSON;
exports.CompetitionEntryUpdateCommandFromJSONTyped = CompetitionEntryUpdateCommandFromJSONTyped;
exports.CompetitionEntryUpdateCommandToJSON = CompetitionEntryUpdateCommandToJSON;
exports.CompetitionEntryUpdateCommandToJSONTyped = CompetitionEntryUpdateCommandToJSONTyped;
var JoinRestriction_1 = require("./JoinRestriction");
var CompetitionEntrySectionSaveCommand_1 = require("./CompetitionEntrySectionSaveCommand");
/**
 * Check if a given object implements the CompetitionEntryUpdateCommand interface.
 */
function instanceOfCompetitionEntryUpdateCommand(value) {
    return true;
}
function CompetitionEntryUpdateCommandFromJSON(json) {
    return CompetitionEntryUpdateCommandFromJSONTyped(json, false);
}
function CompetitionEntryUpdateCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'representing': json['representing'] == null ? undefined : json['representing'],
        'leader': json['leader'] == null ? undefined : json['leader'],
        'alternateName': json['alternateName'] == null ? undefined : json['alternateName'],
        'joinRestriction': json['joinRestriction'] == null ? undefined : (0, JoinRestriction_1.JoinRestrictionFromJSON)(json['joinRestriction']),
        'playingFor': json['playingFor'] == null ? undefined : json['playingFor'],
        'description': json['description'] == null ? undefined : json['description'],
        'abbreviation': json['abbreviation'] == null ? undefined : json['abbreviation'],
        'clearAbbreviation': json['clearAbbreviation'] == null ? undefined : json['clearAbbreviation'],
        'rank': json['rank'] == null ? undefined : json['rank'],
        'clearRank': json['clearRank'] == null ? undefined : json['clearRank'],
        'seed': json['seed'] == null ? undefined : json['seed'],
        'clearSeed': json['clearSeed'] == null ? undefined : json['clearSeed'],
        'descriptionAlert': json['descriptionAlert'] == null ? undefined : json['descriptionAlert'],
        'lookingForMore': json['lookingForMore'] == null ? undefined : json['lookingForMore'],
        'clearRepresenting': json['clearRepresenting'] == null ? undefined : json['clearRepresenting'],
        'section': json['section'] == null ? undefined : (0, CompetitionEntrySectionSaveCommand_1.CompetitionEntrySectionSaveCommandFromJSON)(json['section']),
        'initialRating': json['initialRating'] == null ? undefined : json['initialRating'],
        'image': json['image'] == null ? undefined : json['image'],
        'clearImage': json['clearImage'] == null ? undefined : json['clearImage'],
    };
}
function CompetitionEntryUpdateCommandToJSON(json) {
    return CompetitionEntryUpdateCommandToJSONTyped(json, false);
}
function CompetitionEntryUpdateCommandToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'representing': value['representing'],
        'leader': value['leader'],
        'alternateName': value['alternateName'],
        'joinRestriction': (0, JoinRestriction_1.JoinRestrictionToJSON)(value['joinRestriction']),
        'playingFor': value['playingFor'],
        'description': value['description'],
        'abbreviation': value['abbreviation'],
        'clearAbbreviation': value['clearAbbreviation'],
        'rank': value['rank'],
        'clearRank': value['clearRank'],
        'seed': value['seed'],
        'clearSeed': value['clearSeed'],
        'descriptionAlert': value['descriptionAlert'],
        'lookingForMore': value['lookingForMore'],
        'clearRepresenting': value['clearRepresenting'],
        'section': (0, CompetitionEntrySectionSaveCommand_1.CompetitionEntrySectionSaveCommandToJSON)(value['section']),
        'initialRating': value['initialRating'],
        'image': value['image'],
        'clearImage': value['clearImage'],
    };
}
